import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/ordenes-compra',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['122'],
  cita: 'Areas/ReportesBI/Controllers/OrdenesCompraController.cs',
} satisfies RutaProd;
